// src/pages/Home.js
import React, { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import DentalLogo from "../assets/images/dentallabor_schreiber.png";
import ForgetImage from "../assets/images/Forgot pass.png";
import axiosInstance from "../services/axiosInstance";
import ForgotPopup from "../Popup/forgotPopup";
import { ERROR_MESSAGES_FORGOT } from "../enums/Constants";
import { CircularProgress } from "@mui/material";

const Forgot = () => {
  const [isLoading, setIsLoading] = useState(false);
  const [formData, setFormData] = useState({
    emailid: "",
  });
  const [errors, setErrors] = useState({});
  const [formError, setFormError] = useState("");
  const [openPopup, setOpenPopup] = useState(false);

  const HandleClosePopup = () => setOpenPopup(false);

  const handleChange = (e) => {
    const { id, value } = e.target;
    setFormData({ ...formData, [id]: value });

    // Reset error for the field
    setErrors({ ...errors, [id]: "" });
  };

  const validateForm = () => {
    let isValid = true;
    const newErrors = {};

    if (!formData.emailid) {
      isValid = false;
      newErrors.emailid = ERROR_MESSAGES_FORGOT.REQUIRED;
    } else if (!/^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(formData.emailid)) {
      isValid = false;
      newErrors.emailid = ERROR_MESSAGES_FORGOT.FORMAT;
    }

    setErrors(newErrors);
    return isValid;
  };

  const handleSubmit = () => {
    if (validateForm()) {
      fetchUserData();
    }
  };

  const fetchUserData = async () => {
    try {
      setIsLoading(true);
      const response = await axiosInstance.post("/api/auth/forgetPassword", {
        Email: formData.emailid,
      });
      if (response) {
        setFormError("");
        setOpenPopup(true);
      }
    } catch (error) {
      console.error("Failed to fetch user data:", error);
      if (error.response && error.response.data) {
        const serverErrors = error.response.data.message || error.response.data;
        setFormError(serverErrors || ERROR_MESSAGES_FORGOT.UNEXPECTED);
      } else {
        setFormError(ERROR_MESSAGES_FORGOT.UNEXPECTED);
      }
    } finally {
      setIsLoading(false);
    }
  };

  useEffect(() => {
    document.body.classList.add("login-page");

    // Cleanup: Remove the class when component unmounts
    return () => {
      document.body.classList.remove("login-page");
    };
  }, []);

  return (
    <div className="flex items-center h-screen">
      {/* component 1 */}
      <div className="lg:w-1/2 w-full lg:block hidden">
        <img
          src={ForgetImage}
          alt="Login"
          className=" w-full object-cover h-screen"
        />
      </div>
      {/* component 2 */}
      <div
        className="relative self-center lg:w-1/2 w-full h-full px-5 flex justify-center items-center 
        before:content-[''] before:bottom-0 before:right-0 before:w-full before:h-full before:bg-auto before:bg-right-bottom before:bg-no-repeat before:absolute before:bg-[url('./assets/images/schreiber-right.svg')] 
        before:lg:bg-transparent before:bg-[#0000004a] after:content-[''] after:bottom-0 after:left-0 after:w-[150px] after:h-[166px] after:bg-auto after:bg-left-bottom after:bg-no-repeat after:absolute after:bg-[url('./assets/images/schreiber-left.svg')] 
        "
      >
        <div className="relative 2xl:w-5/12 xl:w-1/2 lg:w-3/4 w-5/6 bg-white rounded-3xl lg:p-0 p-8">
          <img
            src={DentalLogo}
            className="mx-auto"
            alt="Dentallabor Schreiber"
          />
          <h1 className="pt-7 lg:pt-10 2xl:pt-20 text-center text-5xl font-bold font-roboto text-gray-600 mb-8">
            Forgot Your Pin?
          </h1>
          {formError && <p className="text-red text-sm">{formError}</p>}
          <form className="login_page">
            <div className="mb-5 font-inter">
              <label
                className="block text-gray-600 text-2xl font-medium font-inter mb-2"
                htmlFor="id"
              >
                Geben Sie Ihre E-Mail-Adresse Ein
              </label>
              <input
                className={`appearance-none border font-regular font-inter  border-gray rounded-lg w-full py-3 px-5 text-gray-600 placeholder:text-gray-400 focus:outline-none focus:shadow-outline ${
                  errors.emailid ? "border-red" : ""
                }`}
                id="emailid"
                type="text"
                placeholder="E-Mail-Adresse"
                value={formData.emailid}
                onChange={handleChange}
              />
              {errors.emailid && (
                <p className="text-red text-sm mt-1">{errors.emailid}</p>
              )}
            </div>
            <button
              className="bg-blue w-full uppercase hover:bg-blue-800 text-white font-roboto font-bold py-3 px-5 rounded-xl focus:outline-none focus:shadow-outline transition-all ease-in flex justify-center items-center"
              type="button"
              onClick={handleSubmit}
              disabled={isLoading}
            >
              <CircularProgress
                size={20}
                color="inherit"
                className="mr-2"
                style={{ visibility: isLoading ? "visible" : "hidden" }} // Reserve space without changing width
              />
              CONTINUE
            </button>
            <div className="text-center mt-5">
              <Link
                className="inline-block text-center font-bold font-inter text-2xl text-gray-700 transition-all ease-in hover:text-dark-gray"
                to="/"
              >
                Zurück zum Login
              </Link>
            </div>
          </form>
        </div>
      </div>
      <ForgotPopup openPopUp={openPopup} closePopUp={HandleClosePopup} />
    </div>
  );
};

export default Forgot;
